import { z } from 'zod/v4';

export const CompanyClientActionBodySchema = z.object({
  companyIds: z
    .array(z.string())
    .min(1)
    .refine(ids => new Set(ids).size === ids.length, {
      message: 'companyIds must not contain duplicates',
    }),
});

export type CompanyClientActionBody = z.infer<
  typeof CompanyClientActionBodySchema
>;
